import FrameworkCourseController from '../../../framework-course.controller';

class Diagram5Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 7;
    this.clearDiagramId = 3
    this.exerciseId = 'exercise-3';
    this.pyramidData = {
      exerciseNumber: 3,
      scheme: {
        model: {
          textarea: 'ISG’s strategy should be to move in slowly, and expand as its strengths grow',
        },
        children: [
          {
            model: {
              textarea: 'Start as niche provider of systems, management & maintenance in non-DOD markets',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Enter via an enabling acquisition',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Develop a srrong market-oriented organization',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Migrate from niche provider to broader market coverage',
            },
            children: [

            ]
          },
        ],
      },
      scq: {
        's-header': 'Sol-1, DE, R2-a',
        'c-header': 'R1-b, R2-b',
      },
    };
  }

}

export default Diagram5Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram5/diagram5.controller.js